import componentStyle from "./Footer.module.scss";

const Footer = () => {
  return (
    <div className={componentStyle.container}>Spain Startup Jobs 2022 ©</div>
  );
};

export default Footer;
